const badgeStyles = {
  discount: 'bg-red-50 text-red-700',
  bestseller: 'bg-amber-50 text-amber-700',
  new: 'bg-green-50 text-green-700',
  bundle: 'bg-purple-50 text-purple-700',
  package: 'bg-emerald-600 text-white shadow-xs',
  hot: 'bg-red-600 text-white',
  sale: 'bg-orange-500 text-white',
};

const badgeLabels = {
  discount: 'SALE',
  bestseller: 'BESTSELLER',
  new: 'NEW',
  bundle: 'BUNDLE',
  package: '5-IN-1 PACKAGE',
  hot: 'HOT',
  sale: 'SALE',
};

export function Badge({ type, children, className = '' }) {
  if (type && badgeStyles[type]) {
    return (
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold ${badgeStyles[type]} ${className}`}>
        {badgeLabels[type]}
      </span>
    );
  }
  
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${className}`}>
      {children}
    </span>
  );
}

export function BadgeGroup({ badges = [], maxVisible = 2, className = '' }) {
  const visibleBadges = badges.slice(0, maxVisible);
  const remaining = badges.length - maxVisible;
  
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {visibleBadges.map((badge, index) => (
        <Badge key={index} type={badge} />
      ))}
      {remaining > 0 && (
        <Badge className="bg-gray-100 text-gray-600">+{remaining}</Badge>
      )}
    </div>
  );
}